import React from 'react';

// Styles & Assets
import styles from './LegendPharmacy.module.css';

// Hooks
import { useTranslation } from 'react-i18next';

const LegendPharmacy: React.FC = () => {

    const { t } = useTranslation();

    return (
        <div className={styles.legendContainer}>
            <div className={styles.legend}>
                <div className={`${styles.circle} ${styles.greenCircle}`}></div>
                <p className={styles.legendLabel}>{t('taken')}</p>
            </div>
            <div className={styles.legend}>
                <div className={`${styles.circle} ${styles.yellowCircle}`}></div>
                <p className={styles.legendLabel}>{t('forgotten')}</p>
            </div>
            <div className={styles.legend}>
                <div className={`${styles.circle} ${styles.redCircle}`}></div>
                <p className={styles.legendLabel}>{t('not_taken')}</p>
            </div>
        </div>
    );
};

export default LegendPharmacy;